import { useRef, useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { Card } from "@progress/kendo-react-layout";
import { SvgIcon } from "@progress/kendo-react-common";
import signinIcon from "../../assets/signin-icon.svg";
import { userIcon, lockIcon } from "@progress/kendo-svg-icons";
import lockCode from "../../assets/lock-code.png";
import "./login.css";
import { initializeAPI } from "../../api/axios";

const LOGIN_URL = "/clientportalaccount/login";

const Login = () => {
  const { setAuth } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/dashboard";
  const userRef = useRef();

  const [user, setUser] = useState("");
  const [pwd, setPwd] = useState("");
  const [clientCode, setClientCode] = useState("");
  const [region, setRegion] = useState("");
  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    userRef.current.focus();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Initializing the API instance
      const api = initializeAPI();
      const response = await api.post(
        LOGIN_URL,
        JSON.stringify({ username: user, password: pwd, clientCode, region }),
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      const accessToken = response?.data?.data?.access_token;

      if (accessToken) {
        setAuth({ accessToken });
        localStorage.setItem("accessToken", accessToken);
        initializeAPI();
      } else {
        throw new Error("No access token returned.");
      }

      setUser("");
      setPwd("");
      setClientCode("");
      setRegion("");

      navigate(from, { replace: true });
    } catch (err) {
      setErrMsg("Invalid Login");
    }
  };

  return (
    <div className="background-image d-flex justify-content-center align-items-center vh-100 px-4 ">
      {!errMsg ? (
        <Card
          style={{
            maxHeight: "660px",
            height: "88vh",
          }}
          className="card-container overflow-auto px-5 "
        >
          <img
            src={signinIcon}
            alt="signin"
            width={22}
            height={23}
            className="mt-5"
          />

          <h4 className="text-start mt-3">Sign In</h4>
          <span
            style={{
              color: "#6C7384",
            }}
          >
            Welcome back! Please enter your details to sign-in
          </span>
          <form onSubmit={handleSubmit}>
            <div className="mt-5 mb-3">
              <div className="d-flex mb-2 align-items-center">
                <SvgIcon icon={userIcon} />
                <label className="ms-2  fw-semibold ">User Name:</label>
              </div>
              <input
                type="text"
                id="username"
                ref={userRef}
                className="form-input px-4"
                placeholder="Enter Username"
                onChange={(e) => setUser(e.target.value)}
                value={user}
                required
              />
            </div>
            <div className="mb-3">
              <div className="d-flex mb-2 align-items-center">
                <SvgIcon icon={lockIcon} size="medium" />
                <label className="fw-semibold ms-2 ">Password:</label>
              </div>
              <input
                type="password"
                id="password"
                className="form-input px-4"
                placeholder="Enter Password"
                onChange={(e) => setPwd(e.target.value)}
                value={pwd}
                required
              />
            </div>
            <div className="mb-3">
              <div className="d-flex mb-2 align-items-center">
                <img src={lockCode} alt="lockCode" />
                <label className="fw-semibold ms-2">Client Code:</label>
              </div>
              <input
                type="text"
                id="clientCode"
                className="form-input px-4"
                placeholder="Enter Client Code"
                onChange={(e) => setClientCode(e.target.value)}
                value={clientCode}
                required
              />
            </div>

            <div className="d-flex mb-2 align-items-center">
              <img src={lockCode} alt="lockCode" />
              <label className="fw-semibold ms-2">Region:</label>
            </div>
            <input
              type="text"
              id="region"
              value={region}
              onChange={(e) => setRegion(e.target.value)}
              className="form-input px-4"
              placeholder="Enter Region"
              required
            />

            <button
              className="btn w-100 mb-2 "
              style={{
                backgroundColor: "#4F6CF3",
                borderRadius: 10,
                fontSize: 16,
                fontWeight: "500",
                height: 45,
                color: "#FFFFFF",
                marginTop: 35,
              }}
            >
              Sign In
            </button>
          </form>
        </Card>
      ) : (
        <Card
          style={{
            height: 520,
          }}
          className="card-container px-5 "
        >
          <h4 className="text-start mt-5">2 Step Authentication</h4>
          <span>We have sent a code to hello@johnlegal.com</span>
          <div className="inputs mt-5">
            {["", "", "", " ", " ", " "].map((value, index) => {
              return <input key={index} index={index} />;
            })}
          </div>
          <button className="btn btn-primary w-100 mt-4">Sign In</button>
          <button
            className="btn btn-primary w-100 mt-2"
            onClick={() => setErrMsg("")}
          >
            Cancel
          </button>
        </Card>
      )}
    </div>
  );
};

export default Login;
